import '../assets/NcSettingsInputText-w-LprdjK.css';
import { r as n, f as s, a as r } from "./_l10n-BZu8wI2q.mjs";
import { G as u } from "./GenRandomId-BW3iYFf9.mjs";
import { n as l } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
n(s);
const o = {
  name: "NcSettingsInputText",
  props: {
    /**
     * label of the select group element
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * hint of the select group input
     */
    hint: {
      type: String,
      default: ""
    },
    /**
     * value of the select group input
     */
    value: {
      type: String,
      default: ""
    },
    /**
     * disabled state of the settings select group input
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * id attribute of the select group element
     */
    id: {
      type: String,
      default: () => "settings-input-text-" + u(),
      validator: (e) => e.trim() !== ""
    }
  },
  emits: [
    "update:value",
    "input",
    "submit",
    "change"
  ],
  data() {
    return {
      submitTranslated: r("Submit")
    };
  },
  computed: {
    /**
     * @return {string}
     */
    idSubmit() {
      return this.id + "-submit";
    }
  },
  methods: {
    onInput(e) {
      this.$emit("input", e), this.$emit("update:value", e.target.value);
    },
    onSubmit(e) {
      this.disabled || this.$emit("submit", e);
    },
    onChange(e) {
      this.$emit("change", e);
    }
  }
};
var p = function() {
  var t = this, i = t._self._c;
  return i("form", { ref: "form", attrs: { disabled: t.disabled }, on: { submit: function(a) {
    return a.preventDefault(), a.stopPropagation(), t.onSubmit.apply(null, arguments);
  } } }, [i("div", { staticClass: "input-wrapper" }, [i("label", { staticClass: "action-input__label", attrs: { for: t.id } }, [t._v(t._s(t.label))]), i("input", { attrs: { id: t.id, type: "text", disabled: t.disabled }, domProps: { value: t.value }, on: { input: t.onInput, change: t.onChange } }), i("input", { staticClass: "action-input__submit", attrs: { id: t.idSubmit, type: "submit" }, domProps: { value: t.submitTranslated } }), t.hint ? i("p", { staticClass: "hint" }, [t._v(" " + t._s(t.hint) + " ")]) : t._e()])]);
}, d = [], m = /* @__PURE__ */ l(
  o,
  p,
  d,
  !1,
  null,
  "5b140fb6",
  null,
  null
);
const _ = m.exports;
export {
  _ as N
};
